import type { ReactNode } from "react"
import { QuestionCircleOutlined } from "@mimber/ui-web"
import { useHelpGuideUrl } from "../useHelpGuideUrl"
import type { PermissionedMenuItem } from "../usePermissionedMenuItems"

type MenuItemWithHandler = PermissionedMenuItem & {
  label: string
  icon: ReactNode
  onClick: () => void
}

/**
 * Ready-made dropdown menu item for opening the relevant docs help guide.
 * Any dropdown can call this hook once and spread the result into its
 * `items` array -- no refs or per-dropdown wiring required.
 */
export const useHelpGuideMenuItem = (): MenuItemWithHandler => {
  const { openHelpGuide } = useHelpGuideUrl()

  return {
    key: "help-guide",
    icon: <QuestionCircleOutlined />,
    label: "View Help Guides",
    onClick: openHelpGuide,
  }
}
